import React, { useEffect, useMemo } from 'react';
import { useToken } from './useToken';
import { ConfiguracionAlerta } from '../models/administracion/ConfiguracionAlerta';
import { useLazyParams } from '../hooks/useLazyParams';
import { MonitoreoService } from '../service/monitoreo/MonitoreoService';
import { Card } from 'primereact/card';
import { TablaDinamica } from './TablaDinamica';
import { useHistory } from 'react-router-dom';

const Dashboard = () => {
    const { getValorClave } = useToken();
    const puedeVerAlertas = getValorClave('verAlerta') === true;
    const history = useHistory();
    const AlertaModel = useMemo(() => new ConfiguracionAlerta(), []);
    const tablaEstado = useLazyParams({
        modelo: AlertaModel.model
    });
    const monitoreoService = useMemo(() => new MonitoreoService(), []);

    useEffect(() => {
        if (puedeVerAlertas) {
            loadLazyData();
        }
    }, [tablaEstado.lazyParams, puedeVerAlertas]);

    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        const params = { ...tablaEstado.lazyParams };

        monitoreoService.consultarInfo('configuracion-alerta/lista', { lazyEvent: JSON.stringify(params) }).then(res => {
            tablaEstado.setData(res.data.registros || []);
            tablaEstado.setTotalRecords(res.data.total || 0);
        }).catch((error) => {

        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    };

    const onRowSelect = () => {
        history.push('/monitoreo/dashboard');
    };

    return (
        <>
            {puedeVerAlertas ? (
                <div style={{ marginTop: '30px' }}>
                    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                        <img src="assets/layout/images/logoPrelafit.png" alt="Logo Prelafit" style={{ width: '300px', height: 'auto' }} />
                    </div>
                    <Card title="Notificación de Alertas" className="shadow-2" style={{ borderRadius: '12px' }}>
                        <TablaDinamica modelo={AlertaModel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" stripedRows rowHover showGridlines={false} onRowClick={onRowSelect} />
                    </Card>
                </div>
            ) : (
                <img src="assets/layout/images/logoPrelafit.png" alt="Logo Prelafit"
                    style={{ marginLeft: 'auto', marginRight: 'auto', display: 'block', margin: 'auto', verticalAlign: 'middle', marginTop: '200px' }} />
            )}
        </>
    );
};

export default Dashboard;
